export enum WorkOrderStatusSystemName {
    New = 'New',
    Assigned = 'Assigned',
    Dispatched = 'Dispatched',
    SubcontractorDispatched = 'Subcontractor Dispatched',
    Enroute = 'Enroute',
    Onsite = 'Onsite',
    CheckedOut = 'Checked Out',
    InProgress = 'In Progress',
    OnHold = 'On Hold',
    Billed = 'Billed',
    Completed = 'Completed',
    Closed = 'Closed',
    Canceled = 'Canceled',
    Paid = 'Paid',
    Finalised = 'Finalised',
    ResumeAllocation = 'Resume',
    Reverse = 'Reverse'
}

export const ActiveJobStatus = [
    WorkOrderStatusSystemName.Enroute,
    WorkOrderStatusSystemName.Onsite
];
